// Liberías
import React, { Component } from "react";
// Componentes
import Book from "./Utils/Book";
import Info from "./Utils/PropertyInfo";
import Gallery from "./Utils/PropertyGallery";
import Location from "./Utils/property-location/PropertyLocation";
import Properties from "./Utils/PropertyProperties";
import Reviews from "./Utils/PropertyReviews";
import ExploreAloharLinks from "./Utils/ExploreAloharLinks";
import Separator from "../Utils/Separator";
// Assets
import "../../assets/styles/PropertyPage/_property_page.sass";

class PropertyComponent extends Component {
  renderGallery = () => {
    const { images, video } = this.props;
    
    // ✅ Usar el componente Gallery optimizado existente
    return <Gallery images={images} video={video} />;
  };

  render() {
    return (
      <React.Fragment>
        <div className="PropertyComponent">
          {this.renderGallery()}
          <div className="PropertyComponent__info">
            <Info housing={this.props.housing} />
            <div className="PropertyComponent__info__sidebar">
              <Book housing={this.props.housing} />
              {/* <Calendar /> */}
            </div>
          </div>
          <div className="PropertyComponent__location">
            <Location housing={this.props.housing} />
          </div>

          <div className="PropertyComponent__reviews">
            <Separator />
            <Reviews housing={this.props.housing.id} />
            <Separator />
          </div>
          <div className="PropertyComponent__explore">
            <ExploreAloharLinks housing={this.props.housing} />
          </div>
          <div className="PropertyComponent__properties">
            <Properties housing={this.props.housing} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default PropertyComponent;
